var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMyPageKakao(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 70,
    height: 70,
    viewBox: "0 0 70 70",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_19999",
    "data-name": "\\uADF8\\uB8F9 19999",
    transform: "translate(-709 -814)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "\\uD0C0\\uC6D0_1176",
    "data-name": "\\uD0C0\\uC6D0 1176",
    cx: 35,
    cy: 35,
    r: 35,
    transform: "translate(709 814)",
    fill: "#fede32"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD569\\uCE58\\uAE30_5",
    "data-name": "\\uD569\\uCE58\\uAE30 5",
    d: "M7.406,22.979l.1-.265C3.269,20.5.5,16.85.5,12.719.5,5.97,7.887.5,17,.5S33.5,5.97,33.5,12.719,26.113,24.938,17,24.938a22.221,22.221,0,0,1-3.173-.226L6.6,29.111Z",
    transform: "translate(727 834.194)",
    fill: "#fff"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMyPageKakao);
export default __webpack_public_path__ + "static/media/MyPageKakao.77632aba109646308b390949dd5ddb75.svg";
export { ForwardRef as ReactComponent };